var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZipper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 6H8.69763L9.32019 0.745361C9.32227 0.732666 9.32288 0.680054 9.32288 0.666626C9.32288 0.292725 9.03027 0 8.65625 0C8.44763 0 8.24756 0.0993653 8.1123 0.281982L2.78955 8.26672C2.70361 8.38135 2.65625 8.52332 2.65625 8.66663C2.65625 9.04065 2.94897 9.33337 3.32288 9.33337H6.6189L5.99158 15.2646C5.99023 15.2766 5.98962 15.3213 5.98962 15.3334C5.98962 15.7073 6.28223 16 6.65625 16C6.86487 16 7.06494 15.9006 7.1969 15.7227L13.1896 7.06665C13.2756 6.95203 13.3229 6.81006 13.3229 6.66663C13.3229 6.29272 13.0303 6 12.6562 6Z",
    fill: "#FFA800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipper);
export default __webpack_public_path__ + "static/media/zipper.1ebb6d479756b4cd5f8fab0bf91c44e6.svg";
export { ForwardRef as ReactComponent };